module.exports = __webpack_public_path__ + "static/media/ticketing-card.ad7f3b62.png";